<template>
  <span class="font-size-smaller" :class="classes"> {{ wordCount }} / {{ maxWord }}</span>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    wordCount: {
      type: Number
    },
    maxWord: {
      type: Number
    },
    error: {
      type: Boolean
    }
  },
  setup(props){
    const classes = computed(()=>{
      return props.error ? 'error--text' : '';
    });

    return {
      classes
    }
  },
})
</script>
